var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4433_16568)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4433_16568",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4433_16568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2517 0H4.74831C2.12589 0 0 2.12589 0 4.74831V27.2517C0 29.8741 2.12589 32 4.74831 32H27.2517C29.8741 32 32 29.8741 32 27.2517V4.74831C32 2.12589 29.8741 0 27.2517 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 27.8729C15.5667 27.8729 15.154 27.7019 14.8455 27.3934L5.49065 18.0386C2.46407 15.012 2.32233 10.0636 5.16965 7.00366C6.6746 5.38615 8.7215 4.49402 10.9268 4.49402C12.807 4.49402 14.5829 5.14853 16.0003 6.34915C17.4177 5.14853 19.1936 4.49402 21.0738 4.49402C23.2791 4.49402 25.326 5.38615 26.8309 7.00366C29.6782 10.0636 29.5365 15.012 26.5099 18.0386L17.1551 27.3934C16.8466 27.7019 16.438 27.8729 16.0003 27.8729Z",
    fill: "#FF2E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0736 5.18602C22.9913 5.18602 24.9048 5.94892 26.3264 7.47471C28.9778 10.322 28.7735 14.8035 26.0221 17.555L16.6672 26.9098C16.4838 27.0933 16.242 27.185 16.0002 27.185C15.7584 27.185 15.5166 27.0933 15.3332 26.9098L5.97829 17.555C3.22685 14.8035 3.02258 10.322 5.67396 7.47471C7.09553 5.94892 9.0132 5.18602 10.9267 5.18602C12.761 5.18602 14.5994 5.88638 16.0002 7.28711C17.4009 5.88638 19.2352 5.18602 21.0736 5.18602ZM21.0736 3.8103C19.2227 3.8103 17.4634 4.39394 16.0002 5.47367C14.5411 4.39394 12.7777 3.8103 10.9267 3.8103C8.56296 3.8103 6.27844 4.80249 4.6651 6.53672C1.56765 9.86346 1.71773 15.2413 5.00278 18.5263L14.3576 27.8812C14.7954 28.3189 15.379 28.5607 15.996 28.5607C16.613 28.5607 17.1966 28.3189 17.6344 27.8812L26.9892 18.5263C30.2743 15.2413 30.4244 9.86346 27.3269 6.53672C25.7136 4.80249 23.429 3.8103 21.0653 3.8103H21.0736Z",
    fill: "#FF2935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 27.6018C15.6371 27.6018 15.2953 27.46 15.0368 27.2016L5.68194 17.8467C2.75959 14.9243 2.61785 10.1427 5.36928 7.19114C6.82421 5.62782 8.80023 4.76904 10.9263 4.76904C12.819 4.76904 14.6033 5.4569 15.9998 6.71172C17.3964 5.4569 19.1806 4.76904 21.0733 4.76904C23.2036 4.76904 25.1796 5.62782 26.6304 7.19114C29.3818 10.1427 29.24 14.9243 26.3177 17.8467L16.9628 27.2016C16.7044 27.46 16.3625 27.6018 15.9998 27.6018Z",
    fill: "#780449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0733 5.18594C22.991 5.18594 24.9045 5.94884 26.3261 7.47463C28.9774 10.3219 28.7732 14.8034 26.0217 17.5549L16.6669 26.9098C16.4834 27.0932 16.2416 27.1849 15.9998 27.1849C15.758 27.1849 15.5163 27.0932 15.3328 26.9098L5.97795 17.5549C3.22652 14.8034 3.02225 10.3219 5.67363 7.47463C7.0952 5.94884 9.01287 5.18594 10.9264 5.18594C12.7607 5.18594 14.5991 5.88631 15.9998 7.28703C17.4006 5.88631 19.2349 5.18594 21.0733 5.18594ZM21.0733 4.35217C19.2015 4.35217 17.4298 4.99001 15.9998 6.16145C14.5741 4.99001 12.7982 4.35217 10.9264 4.35217C8.67936 4.35217 6.59494 5.26098 5.06081 6.90767C2.1593 10.0218 2.30521 15.0619 5.38598 18.1427L14.7409 27.4976C15.0785 27.8352 15.5246 28.0187 15.9957 28.0187C16.4668 28.0187 16.917 27.8352 17.2505 27.4976L26.6054 18.1427C29.6861 15.0619 29.832 10.0218 26.9305 6.90767C25.4172 5.28599 23.2828 4.35217 21.065 4.35217H21.0733Z",
    fill: "#780449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3262 7.10366C23.5414 4.1146 18.864 4.05207 16 6.91606C13.136 4.05207 8.45857 4.1146 5.67379 7.10366C3.02241 9.95098 3.22668 14.4325 5.97811 17.1839L15.333 26.5388C15.6998 26.9056 16.3002 26.9056 16.667 26.5388L26.0219 17.1839C28.7733 14.4325 28.9776 9.95098 26.3262 7.10366Z",
    fill: "url(#paint0_radial_4433_16568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5225 7.33728C26.8851 11.7312 24.709 16.4045 20.4776 19.306C17.3593 21.4446 13.745 22.195 10.4683 21.6739L15.3333 26.5389C15.7002 26.9058 16.3005 26.9058 16.6673 26.5389L26.0222 17.1841C28.6986 14.5077 28.9571 10.1929 26.5225 7.33728Z",
    fill: "#BD000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36556 9.40074C7.34158 5.44869 11.9732 4.45233 15.3124 6.31997C12.4317 4.08548 8.24205 4.34395 5.66988 7.10372C3.0185 9.95103 3.22277 14.4325 5.97421 17.184L6.69125 17.901C6.69125 17.901 3.38119 13.3653 5.36556 9.40074Z",
    fill: "#FFB5CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67409 7.10363C4.26086 8.62108 3.66471 10.6055 3.83147 12.544C5.59072 13.1943 7.77936 12.7024 9.34684 11.1391C11.1561 9.32979 11.5313 6.69091 10.3724 4.84412C8.64647 4.97752 6.95809 5.72791 5.67409 7.10363Z",
    fill: "#FFB5CB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4433_16568",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.925 2.73472) scale(25.2923 25.2923)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4433_16568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBadge);
export default __webpack_public_path__ + "static/media/heart-badge.250fe635f186e40c7e0bef0022c40c66.svg";
export { ForwardRef as ReactComponent };